import React, { useRef, useEffect, useState } from "react";
import axios from "axios";

// Import Swiper
import { SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Mousewheel } from 'swiper/modules';
import { register } from 'swiper/element/bundle';

// import component
import Slide1 from './Slide1Comp';
import Slide2 from './Slide2Comp';
import Slide3 from './Slide3Comp';
import Slide4 from './Slide4Comp';
import Slide5 from './Slide5Comp';
import Slide6 from './Slide6Comp';

const AccueilPage = () => {
    const swiperRef = useRef(null);

    //swiper init
    useEffect(() => {
        register();

        const params = {
            slidesPerView: 1,
            direction: 'vertical',
            mousewheel: true,
            speed: 900,
            modules: [Mousewheel],
            className: "homeSwiper",
            on: {
                slideChange: () => handleSlideChange(),
            }

        };
        Object.assign(swiperRef.current, params);
        swiperRef.current.initialize();

    }, []);

    //Animation du menu et position au demarage
    const handleSlideChange = (e) => {
        let focusUl = document.querySelector(".menuUl");
        let listItems = focusUl.querySelectorAll("li");
        let menuSlider = document.querySelector(".navMenu__scrolldetect");

        listItems.forEach((li, index) => {
            if (index === swiperRef.current.swiper.realIndex) {
                li.firstChild.classList.add("menuActive");
                const liPosition = li.offsetTop; // Obtient la position par rapport à son parent (.menuUl)
                menuSlider.style.transform = `translateY(${liPosition}px)`;
            } else {
                li.firstChild.classList.remove("menuActive");
            }
        });
    };

    const positionnerSlider = (swiper) => {
        let focusUl = document.querySelector(".menuUl");
        let listItems = focusUl.querySelectorAll("li");
        let menuSlider = document.querySelector(".navMenu__scrolldetect");

        listItems.forEach((li, index) => {
            if (index === swiper) {
                li.firstChild.classList.add("menuActive");
                const liPosition = li.offsetTop;
                menuSlider.style.transform = `translateY(${liPosition}px)`;
            } else {
                li.firstChild.classList.remove("menuActive");
            }
        });
    };

    //lien d'ancrage menu
    const menuAnchor = (e) => {

        switch (e.target.innerText) {
            case "Accueil":
                swiperRef.current.swiper.slideTo(0, 1000, false)
                break;

            case "FCU News":
                swiperRef.current.swiper.slideTo(1, 1000, false)
                break;

            case "carrières":
                swiperRef.current.swiper.slideTo(2, 1000, false)
                break;

            case "Médias":
                swiperRef.current.swiper.slideTo(3, 1000, false)
                break;

            case "F.A.Q":
                swiperRef.current.swiper.slideTo(4, 1000, false)
                break;

            case "S'enrôler":
                swiperRef.current.swiper.slideTo(5, 1000, false)
                break;

            default:
                break;
        }
    }

    useEffect(() => {

        //position du menu au demarage
        const swiper = 0;
        positionnerSlider(swiper);

    }, []);


    return (
        <>
            <div className='homePage'>

                <div className="navMenu">

                    <ul className="menuUl">
                        <li><p onClick={menuAnchor} className="menuLi">Accueil</p></li>
                        <li><p onClick={menuAnchor} className="menuLi">FCU News</p></li>
                        <li><p onClick={menuAnchor} className="menuLi">carrières</p></li>
                        <li><p onClick={menuAnchor} className="menuLi">Médias</p></li>
                        {/* <li><p onClick={menuAnchor} className="menuLi">F.A.Q</p></li> */}
                        <li><p onClick={menuAnchor} className="menuLi">S'enrôler</p></li>
                    </ul>

                    <span className="navMenu__scrolldetect"></span>
                </div>

                <swiper-container init="false" ref={swiperRef}>

                    <SwiperSlide className="slide1" >
                        <Slide1 />
                    </SwiperSlide>

                    <SwiperSlide className="slide2">
                        <Slide2 />
                    </SwiperSlide>

                    <SwiperSlide className="slide3">
                        <Slide3 />
                    </SwiperSlide>

                    <SwiperSlide className="slide4">
                        <Slide4 />
                    </SwiperSlide>

                    {/* <SwiperSlide className="slide5">
                        <Slide5 />
                    </SwiperSlide> */}

                    <SwiperSlide className="slide6">
                        <Slide6 />
                    </SwiperSlide>

                </swiper-container>

            </div>
        </>
    );
}

export default AccueilPage;
